import type { InternalApiKeysTranslations } from "../interfaces/internalApiKeys";

export const internalApiKeysTranslations: InternalApiKeysTranslations = {
  page_title: "Llaves internas",
  page_subtitle:
    "Llaves para que los sistemas de Coloca, como el CRM, usen la API interna sin usuario ni contraseña. Cada cambio pide tu código de verificación, salvo apagar o revocar.",
  action_refresh: "Actualizar",
  action_new: "Nueva llave",
  action_retry: "Reintentar",
  surface_off: "La API interna está apagada en este ambiente. Las llaves no responden hasta que se prenda.",
  access_failed: "No pudimos comprobar tu acceso a las llaves internas. Vuelve a intentar en un momento.",

  empty_title: "Todavía no hay llaves internas",
  empty_description: "Crea una para que el CRM deje de entrar con usuario y contraseña.",

  status_ACTIVE: "Activa",
  status_DISABLED: "Apagada",
  status_NO_IP: "Sin IP",
  status_EXPIRED: "Vencida",
  status_REVOKED: "Revocada",

  row_all_organizations: "Todas las organizaciones",
  row_organizations_one: "1 organización",
  row_organizations_other: "{{count}} organizaciones",
  row_permissions_all: "Permisos: todos",
  row_permissions: "Permisos: {{list}}",
  row_no_ip: "Sin IP permitida",
  row_ips: "IP {{ips}}",
  row_no_ip_low_risk: "Sin IP (titulares desde cualquier IP)",
  row_ips_low_risk: "IP {{ips}} · titulares desde cualquier IP",
  row_expires: "Vence el {{date}}",
  row_expired: "Venció el {{date}}",
  row_revoked: "Revocada el {{date}}",
  row_last_used: "Último uso {{date}} desde {{ip}}",
  row_never_used: "Sin uso todavía",
  row_rotation_grace: "El secreto anterior funciona hasta el {{date}}",
  switch_label: "Prender o apagar {{name}}",
  switch_needs_ip: "Agrega una IP para prenderla",
  switch_needs_expiry: "Extiende el vencimiento para prenderla",
  menu_label: "Acciones de {{name}}",

  action_edit: "Editar",
  action_edit_ips: "Editar IPs",
  action_rotate: "Cambiar el secreto",
  action_usage: "Ver el uso",
  action_revoke: "Revocar",
  cancel: "Cancelar",

  toast_created: "Llave creada",
  toast_updated: "Cambios guardados",
  toast_ips_updated: "IPs guardadas",
  toast_enabled: "Llave prendida",
  toast_disabled: "Llave apagada",
  toast_rotated: "Secreto cambiado",
  toast_revoked: "Llave revocada",

  revoke_title: "¿Revocar {{name}}?",
  revoke_description:
    "Deja de funcionar al instante y no se puede volver a usar. El sistema que la usa recibe 404 hasta que tenga una llave nueva.",
  revoke_confirm: "Revocar",
  rotate_title: "¿Cambiar el secreto de {{name}}?",
  rotate_description_grace:
    "Se genera un secreto nuevo. El anterior sigue funcionando {{hours}} horas para que el sistema que la usa alcance a cambiarlo.",
  rotate_description_now: "Se genera un secreto nuevo y el anterior deja de funcionar al instante.",
  rotate_retire_now_label: "El secreto se filtró: dejar de aceptar el anterior ya",
  rotate_retire_now_hint: "El sistema que usa la llave falla hasta que le pongas el secreto nuevo.",
  rotate_confirm: "Cambiar el secreto",

  token_title_created: "Copia la llave de {{name}} ahora",
  token_title_rotated: "Copia el secreto nuevo de {{name}} ahora",
  token_warning:
    "No se vuelve a mostrar. Pásala por un gestor de secretos o de contraseñas, nunca por chat ni correo.",
  token_copy: "Copiar",
  token_copied: "Copiada",
  token_dismiss: "Ya la guardé",

  form_title_create: "Nueva llave interna",
  form_title_edit: "Editar {{name}}",
  form_description: "Qué puede hacer la llave, sobre qué organizaciones y desde qué IP.",
  field_name: "Nombre",
  field_name_placeholder: "CRM",
  field_description: "Para qué es (opcional)",
  section_permissions: "Permisos",
  all_permissions_label: "Todos los permisos",
  all_permissions_hint: "Incluye los que se agreguen a la API interna más adelante.",
  permission_operation_payments_read: "Ver órdenes de pago",
  permission_operation_payments_create: "Crear órdenes de pago",
  permission_operation_payments_cancel: "Cancelar órdenes pendientes",
  permission_clients_read: "Ver clientes",
  permission_clients_write: "Crear y editar clientes",
  permission_client_accounts_write: "Registrar cuentas de clientes",
  permission_cardholders_write: "Dar de alta titulares (y reintentar su registro)",
  section_organizations: "Organizaciones",
  all_organizations_label: "Todas las organizaciones",
  all_organizations_hint: "La llave podrá crear y leer órdenes y clientes de cualquier organización.",
  organizations_add: "Agregar organización",
  organizations_add_hint: "Fuera de estas organizaciones la llave recibe 404.",
  organizations_remove: "Quitar {{name}}",
  section_ips: "IPs permitidas",
  ips_hint:
    "IPs públicas exactas, hasta 10. Sin IP la llave solo se puede prender si permite el alta de titulares desde cualquier IP.",
  allow_without_ip_label: "Permitir el alta de titulares desde cualquier IP",
  allow_without_ip_hint:
    "Solo para dar de alta titulares y reintentar su registro. Los pagos y los clientes siguen exigiendo una IP de la lista.",
  ip_label: "IP",
  ip_placeholder: "54.213.10.45",
  ip_label_placeholder: "Etiqueta (opcional)",
  ip_add: "Agregar",
  ip_remove: "Quitar {{ip}}",
  ip_invalid: "Escribe una IP válida (IPv4 o IPv6), sin rangos.",
  ip_duplicate: "Esa IP ya está en la lista.",
  ips_dialog_title: "IPs de {{name}}",
  ips_dialog_submit: "Guardar IPs",
  ips_dialog_turns_off: "Sin IPs la llave se apaga al guardar y no se puede prender hasta que agregues una.",
  ips_dialog_only_cardholders:
    "Sin IPs la llave solo podrá dar de alta titulares. Los pagos y los clientes recibirán 404.",
  section_limits: "Vencimiento y límite",
  field_expires_on: "Funciona hasta",
  field_expires_hint: "Máximo {{days}} días desde hoy.",
  field_rate_limit: "Solicitudes por minuto",
  field_rate_limit_hint: "Pasado el límite responde 429 hasta el minuto siguiente.",
  error_name: "Escribe un nombre de al menos 3 caracteres.",
  error_permissions: "Elige al menos un permiso, o todos.",
  error_organizations: "Elige al menos una organización, o todas.",
  error_expiry: "Elige hasta cuándo funciona.",
  error_rate_limit: "Escribe un número entre 1 y 6000.",
  error_ips: "Hasta 10 IPs.",
  form_submit_create: "Crear llave",
  form_submit_edit: "Guardar cambios",

  two_factor_required: "Para crear o cambiar llaves internas necesitas la verificación en dos pasos.",
  two_factor_challenge: "Escribe el código de tu app de autenticación para confirmar.",

  usage_title: "Uso de {{name}}",
  usage_description: "Cada solicitud que llegó con esta llave, también las rechazadas.",
  usage_empty: "Sin solicitudes todavía",
  usage_status: "HTTP {{code}}",
  outcome_OK: "Aceptada",
  outcome_SURFACE_OFF: "API interna apagada",
  outcome_ORIGIN_REJECTED: "Llegó desde un navegador",
  outcome_MISSING_KEY: "Sin llave",
  outcome_MALFORMED_KEY: "Llave con formato inválido",
  outcome_WRONG_ENV: "Llave de otro ambiente",
  outcome_UNKNOWN_KEY: "Llave desconocida",
  outcome_BAD_SECRET: "Secreto incorrecto",
  outcome_REVOKED: "Llave revocada",
  outcome_DISABLED: "Llave apagada",
  outcome_EXPIRED: "Llave vencida",
  outcome_IP_BLOCKED: "IP no permitida",
  outcome_SERVICE_USER_INACTIVE: "Usuario de servicio inactivo",
  outcome_FORBIDDEN: "Sin permiso para esa operación",
  outcome_RATE_LIMITED: "Pasó el límite por minuto",
  outcome_ERROR: "Error al verificar la llave",
};
